import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { securityInterceptor } from '../interceptors/security.interceptor';
import { PublicConfigService } from '../services/public-config.service';
import { VersionService } from './core/services/version.service';

function publicConfigFactory(pub: PublicConfigService) {
  return () => pub.load();
}

function versionMetadataFactory(version: VersionService) {
  return () => firstValueFrom(version.load());
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules) // Preload all lazy-loaded routes for faster navigation
    ),
    provideHttpClient(
      withInterceptors([securityInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: publicConfigFactory,
      deps: [PublicConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: versionMetadataFactory,
      deps: [VersionService],
      multi: true,
    },
  ]
};
